import { connect } from 'react-redux';
import {
  changeFilterAction,
  clearFiltersAction,
} from 'src/routes/SeoApp/domain/state/filters/actions';
import { activeFiltersSelector } from 'src/routes/SeoApp/domain/state/filters/selectors';
import { getLinkedDepartures } from 'src/routes/SeoApp/domain/state/linked/selectors';
import { isMapView } from 'src/routes/SeoApp/domain/state/map/selectors';
import EmptyHotels from './EmptyHotels';

const mapStateToProps = (state) => ({
  linkedDepartures: getLinkedDepartures(state),
  activeFilters: activeFiltersSelector(state),
  isMapExpanded: isMapView(state),
});

const mapDispatchToProps = {
  changeFilter: changeFilterAction,
  clearFilters: clearFiltersAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(EmptyHotels);
